import { useEffect, useRef } from 'react';

import { MessageBubble } from '@/components/chat/MessageBubble';
import type { ChatMessage } from '@/store/useApp';

interface MessageListProps {
  messages: ChatMessage[];
}

export function MessageList({ messages }: MessageListProps) {
  const endRef = useRef<HTMLDivElement | null>(null);

  const lastContent = messages[messages.length - 1]?.content;
  useEffect(() => {
    endRef.current?.scrollIntoView({ block: 'end' });
  }, [messages.length, lastContent]);

  if (messages.length === 0) {
    return (
      <div className="flex h-full items-center justify-center px-6 text-center">
        <p className="max-w-xs text-sm text-neutral-500">
          Type a prompt below — e.g. <em>build a hero section in dark mode</em> — and watch the
          design stream into the canvas.
        </p>
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col gap-3 overflow-y-auto overscroll-contain px-4 py-4">
      {messages.map((m) => (
        <MessageBubble key={m.id} message={m} />
      ))}
      <div ref={endRef} aria-hidden="true" />
    </div>
  );
}
